/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Not_Found_TextInputs */



/**
* | output |
* | --- |
* | "The link may be old, or copied wrong. Your projects and your publications have not moved." |
*
* @param {Not_Found_TextInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const not_found_text = /** @type {((inputs?: Not_Found_TextInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Not_Found_TextInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The link may be old, or copied wrong. Your projects and your publications have not moved.")
	return /** @type {LocalizedString} */ ("Le lien est peut-être ancien, ou mal recopié. Vos projets et vos publications, eux, n'ont pas bougé.")
});